import React, { useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx"

import styles from "./accordionItem.module.scss";
import ArrowDown from "@assets/images/svgs/arrow-down.svg";
import { renderWithBreaks } from '@utils/translations';

const AccordionItem = ({ title, text, shouldRenderWithBreaks }) => {
  const [isOpen, setIsOpen] = useState(false)

  const isString = typeof text === 'string';
  const toggleAccordion = () => setIsOpen(prevState => !prevState)

  return (
    <div className={clsx(styles.accordionItem__wrapper)}>
      <div className={clsx(styles.accordionItem__header)} onClick={toggleAccordion}>
        <h2 className={clsx(styles.accordionItem__title)}>{title}</h2>
        <span className={clsx(styles.accordionItem__arrow, { [styles.opened]: isOpen })} aria-label={title}>
          <ArrowDown />
        </span>
      </div>
      <div className={clsx(styles.accordionItem__content, { [styles.closed]: !isOpen })}>
        {!isString || shouldRenderWithBreaks
          ? (<div className={clsx(styles.accordionItem__text)}>
              {isString && shouldRenderWithBreaks ? renderWithBreaks(text) : text}
            </div>)
          : <p className={clsx(styles.accordionItem__text)}>{text}</p>
        }
      </div>
    </div>
  );
}

AccordionItem.propTypes = {
  title: PropTypes.string,
  text: PropTypes.oneOf([PropTypes.string, PropTypes.node]),
  shouldRenderWithBreaks: PropTypes.bool
};

export default AccordionItem;
